export const USER_PROFILE_QUERY = 'userProfile'
